import { MyRadio } from "./MyRadio";
import { meal_box_quantity_option, meal_box_quantity_selected } from "../imgs";
import { MyColor } from "../config/myStyle";
import { useTranslation } from "react-i18next";

export type CouponProps = {
    select?: boolean
    onSelect(amount: CouponProps['amount']): void
    meals: number
    amount: number
}

export const Coupon = (props: CouponProps) => {
    const { t } = useTranslation();
    return (
        <div
            className="flex flex-col"
            style={{ color: MyColor.blue, alignItems: 'center', }}
            onClick={() => props.onSelect(props.amount)}
        >
            <div style={{ position: 'relative' }}>
                <img className="h-[170px]" src={props.select ? meal_box_quantity_selected : meal_box_quantity_option} />
                <div style={{ position: 'absolute', bottom: 8, left: 0, right: 0, lineHeight: 1, textAlign: 'center' }}>
                    <div className="text-[40px] font-[600]">{props.meals}</div>
                    <div className="text-[14px]">{t("campaign_donation.meals")}</div>
                </div>
            </div>
            <div className="text-center text-[18px] font-[600] mt-[5px]">HK${props.amount}</div>
            <MyRadio
                className="mt-[5px]"
                onSelect={() => props.onSelect(props.amount)}
                select={props.select}
            />
        </div>
    )
}
